/**
 * B+D visual redesign — REMEMBERED moment.
 *
 * Displays a single deterministic remembered moment from Gully's stored
 * state. Read-only, verbatim text, never invented.
 *
 * Design: the information is the interface. No card, no border, no icon,
 * no gradient, no uppercase provenance labels. A quiet "Remembered"
 * eyebrow, then the remembered text in the same system font as everything
 * else. Warmth comes from content, spacing and hierarchy — not decoration.
 *
 * Long memories truncate with a "more" expansion so the composer stays
 * visible without scrolling on normal mobile viewports.
 *
 * Props:
 *   moment: {tier, kind, text, display_text, at} from GET /api/home/remembered
 *
 * Renders nothing if moment is null/undefined (per spec: no valid moment
 * = render nothing, never a placeholder).
 */

import React, { useState } from "react";

const TRUNCATE_AT = 140;

export default function RememberedMoment({ moment }) {
  const [expanded, setExpanded] = useState(false);

  // No valid moment = render nothing. Never a placeholder.
  if (!moment || !moment.display_text) {
    return null;
  }

  const full = moment.display_text;
  const truncated = full.length > TRUNCATE_AT && !expanded;

  return (
    <div data-testid="remembered-moment">
      <p className="text-xs text-neutral-500 mb-1.5">Remembered</p>
      <p className="text-[17px] leading-relaxed text-neutral-800">
        &ldquo;{truncated ? full.slice(0, TRUNCATE_AT).trimEnd() + "…" : full}&rdquo;
      </p>
      {truncated && (
        <button
          onClick={() => setExpanded(true)}
          className="text-sm text-neutral-500 mt-1 underline underline-offset-2 decoration-neutral-300"
          data-testid="remembered-moment-more"
        >
          more
        </button>
      )}
    </div>
  );
}
